import { getMainSiteUrl } from "../constants/appConfig";

export function getAcf(page) {
  return page?.acf || {};
}

export function acfText(value) {
  if (value === null || value === undefined) return "";
  return String(value).trim();
}

export function acfList(acf, prefix, count) {
  const items = [];
  for (let i = 1; i <= count; i += 1) {
    const text = acfText(acf[`${prefix}${i}`]);
    if (text) items.push(text);
  }
  return items;
}

export function resolveAcfLink(link) {
  const mainSite = getMainSiteUrl();

  if (!link) return null;

  if (typeof link === "string") {
    const trimmed = link.trim();
    if (!trimmed) return null;
    const href = trimmed.startsWith("/") ? `${mainSite}${trimmed}` : trimmed;
    return { href, label: trimmed, target: "_self" };
  }

  if (typeof link === "object" && link.url) {
    const url = link.url.trim();
    if (!url) return null;
    const href = url.startsWith("/") ? `${mainSite}${url}` : url;
    return {
      href,
      label: acfText(link.title) || href,
      target: link.target || "_self",
    };
  }

  return null;
}

export function collectLandingMediaIds(acf) {
  const ids = new Set();

  const add = (value) => {
    if (typeof value === "number" && value > 0) {
      ids.add(value);
    }
  };

  add(acf.hero_image);
  add(acf.product_1_image);
  add(acf.product_2_image);
  add(acf.product_3_image);

  for (let i = 1; i <= 8; i += 1) {
    add(acf[`project_image_${i}`]);
  }

  return [...ids];
}

export function getLandingProducts(acf) {
  const products = [];

  for (let i = 1; i <= 3; i += 1) {
    const title = acfText(acf[`product_${i}_title`]);
    if (!title) continue;

    products.push({
      id: i,
      title,
      description: acfText(acf[`product_${i}_description`]),
      imageId: acf[`product_${i}_image`],
      ctaText: acfText(acf[`product_${i}_cta_text`]),
      ctaLink: resolveAcfLink(acf[`product_${i}_cta_link`]),
    });
  }

  return products;
}

export function getLandingProjects(acf) {
  const images = [];
  for (let i = 1; i <= 8; i += 1) {
    const imageId = acf[`project_image_${i}`];
    if (typeof imageId === "number" && imageId > 0) {
      images.push({ id: i, imageId });
    }
  }

  return {
    title: acfText(acf.projects_title),
    description: acfText(acf.projects_description),
    images,
  };
}
